import { FunctionComponent } from "react";
import { IconProps } from "./IconProps";

const SmartPhoneIcon: FunctionComponent<IconProps> = ({
  size = 24,
  color,
  testID,
}) => (
  <svg
    width={size}
    height={size}
    color={color}
    data-testid={testID}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M17.5867 1H6.87927C6.3943 1 6 1.3911 6 1.87927V22.1208C6 22.6057 6.3974 23 6.87927 23H17.5867C18.0717 23 18.4659 22.6089 18.4659 22.1208V1.88238C18.4659 1.3974 18.0717 1 17.5867 1ZM12.233 1.73534C12.5991 1.73534 12.8932 2.02946 12.8932 2.39558C12.8932 2.76169 12.5991 3.05582 12.233 3.05582C11.8669 3.05582 11.5728 2.76169 11.5728 2.39558C11.5728 2.02946 11.8669 1.73534 12.233 1.73534ZM12.2674 22.2679C11.7574 22.2679 11.3475 21.858 11.3475 21.348C11.3475 20.8379 11.7574 20.428 12.2674 20.428C12.7775 20.428 13.1873 20.8379 13.1873 21.348C13.1874 21.8579 12.7744 22.2679 12.2674 22.2679ZM17.3677 18.9699C17.3677 19.2139 17.1706 19.4111 16.9266 19.4111H7.53955C7.29549 19.4111 7.09834 19.2139 7.09834 18.9699V4.22913C7.09834 3.98507 7.29549 3.78792 7.53955 3.78792H16.9266C17.1706 3.78792 17.3677 3.98503 17.3677 4.22913V18.9699Z"
    />
  </svg>
);

export { SmartPhoneIcon };
